import { Form } from "react-bootstrap";

const DateInput = (props) => {
  const { name, label, register, errors, disabled = false, type = "date", className = "" } = props;

  return (
    <div className={errors ? "mb-1" : "mb-0"}>
      <Form.Label htmlFor={name}>{label}</Form.Label>
      <Form.Control
        type={type}
        disabled={disabled}
        id={name}
        name={name}
        {...register(name)}
        className={"form-control " + (errors ? " border border-danger " : "") + className}
        step={1}
      />
      {errors && <small className='text-danger mb-0 fw-semibold mt-2'>{errors?.message}</small>}
    </div>
  );
};

export default DateInput;
